// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see DebugMenuDebugOpenMenuEvent
 */
export var DebugMenuDebugOpenMenu = function (_a) {
    var menuVersion = _a.menuVersion;
    return ({
        name: "DebugMenu Debug OpenMenu",
        parameters: {
            cdf_entity: "DebugMenu",
            cdf_action: "Debug",
            menu_version: menuVersion !== undefined && menuVersion !== null ? menuVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DebugMenuDebugCloseMenuEvent
 */
export var DebugMenuDebugCloseMenu = function (_a) {
    var menuVersion = _a.menuVersion, timeElapsedMs = _a.timeElapsedMs;
    return ({
        name: "DebugMenu Debug CloseMenu",
        parameters: {
            cdf_entity: "DebugMenu",
            cdf_action: "Debug",
            menu_version: menuVersion !== undefined && menuVersion !== null ? menuVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            time_elapsed_ms: timeElapsedMs !== undefined && timeElapsedMs !== null ? timeElapsedMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DebugMenuDebugSwitchTabEvent
 */
export var DebugMenuDebugSwitchTab = function (_a) {
    var menuVersion = _a.menuVersion, currentTabName = _a.currentTabName, newTabName = _a.newTabName;
    return ({
        name: "DebugMenu Debug SwitchTab",
        parameters: {
            cdf_entity: "DebugMenu",
            cdf_action: "Debug",
            menu_version: menuVersion !== undefined && menuVersion !== null ? menuVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_tab_name: currentTabName !== undefined && currentTabName !== null ? currentTabName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            new_tab_name: newTabName !== undefined && newTabName !== null ? newTabName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DebugMenuDebugEnterSearchEvent
 */
export var DebugMenuDebugEnterSearch = function (_a) {
    var menuVersion = _a.menuVersion;
    return ({
        name: "DebugMenu Debug EnterSearch",
        parameters: {
            cdf_entity: "DebugMenu",
            cdf_action: "Debug",
            menu_version: menuVersion !== undefined && menuVersion !== null ? menuVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DebugMenuDebugPerformSearchEvent
 */
export var DebugMenuDebugPerformSearch = function (_a) {
    var menuVersion = _a.menuVersion, searchTerm = _a.searchTerm, timeElapsedMs = _a.timeElapsedMs;
    return ({
        name: "DebugMenu Debug PerformSearch",
        parameters: {
            cdf_entity: "DebugMenu",
            cdf_action: "Debug",
            menu_version: menuVersion !== undefined && menuVersion !== null ? menuVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_term: searchTerm !== undefined && searchTerm !== null ? searchTerm.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            time_elapsed_ms: timeElapsedMs !== undefined && timeElapsedMs !== null ? timeElapsedMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DebugMenuDebugDebugSwitchToggledEvent
 */
export var DebugMenuDebugDebugSwitchToggled = function (_a) {
    var menuVersion = _a.menuVersion, switchName = _a.switchName, newValue = _a.newValue;
    return ({
        name: "DebugMenu Debug DebugSwitchToggled",
        parameters: {
            cdf_entity: "DebugMenu",
            cdf_action: "Debug",
            menu_version: menuVersion !== undefined && menuVersion !== null ? menuVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            switch_name: switchName !== undefined && switchName !== null ? switchName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            new_value: newValue !== undefined && newValue !== null ? newValue.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DebugMenuDebugDebugMenuPressedEvent
 */
export var DebugMenuDebugDebugMenuPressed = function (_a) {
    var menuVersion = _a.menuVersion, buttonName = _a.buttonName;
    return ({
        name: "DebugMenu Debug DebugMenuPressed",
        parameters: {
            cdf_entity: "DebugMenu",
            cdf_action: "Debug",
            menu_version: menuVersion !== undefined && menuVersion !== null ? menuVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            button_name: buttonName !== undefined && buttonName !== null ? buttonName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DebugMenuDebugDebugSpinnerSelectedEvent
 */
export var DebugMenuDebugDebugSpinnerSelected = function (_a) {
    var menuVersion = _a.menuVersion, spinnerName = _a.spinnerName, newValue = _a.newValue;
    return ({
        name: "DebugMenu Debug DebugSpinnerSelected",
        parameters: {
            cdf_entity: "DebugMenu",
            cdf_action: "Debug",
            menu_version: menuVersion !== undefined && menuVersion !== null ? menuVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            spinner_name: spinnerName !== undefined && spinnerName !== null ? spinnerName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            new_value: newValue !== undefined && newValue !== null ? newValue.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
